<template>
<div v-if="loading" class="over container">
    <div class="row" style="height: 45vh">
        <div class="col-12"></div>
    </div>
    <div class="row">
        <div class="spinner-border text-primary center" role="status">
            <span class="sr-only"></span>
        </div>
    </div>
</div>
<div v-else class="container mt-0 background"  :class="{ ltr: isEnglish }">
    <!-- *************************SHOW MORE INFO PAGE********************************* -->

    <div id="moreInfo">
        <PointNumberLine class="m-0" :point-number="pointNumber" />

        <div class="row">

            <div class="col-6 presented mb-2" :class="{ alignLeft: isEnglish }">
                
                {{ translation.items }} {{ lang }}

            </div>
            <div class="closingCross col-6" @click="fadeOutMoreInfo" :class="{ alignRight: isEnglish }">
                
                {{ translation.back }}

                <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" fill="currentColor" class="bi bi-x-circle-fill" viewBox="0 0 16 16">
                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
                </svg>
            </div>
        </div>

        <div class="row itemsRow">
            <!-- <div :key="item.id" v-for="item in currentItemsArray" class="col-6 d-flex justify-content-center"> -->
            <div v-for="item in currentItemsArray" :key="item.id" class="col-6 d-flex itemInList">
                <div style="" class="itemSquare mb-2">
                    <div class="pe-0" @click="
              openImageInfo(
                item.point.itemName,
                item.point.imageBase64,
                item.point.material,
                item.point.period,
                item.point.place,
                item.point.pointInformation
              )
            ">
                        <div class="titleSpan">
                            {{ item.point.itemName }}
                        </div>
                        <div style="display: flex; justify-content: center; align-items: center;height: 100px; ">
                            <img :src="item.point.imageBase64" alt="" style="max-width: 100px;">

                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
</template>

<script>
import PointNumberLine from "./pointNumberLine";

// import Map from "./map";
export default {
    // props: ["pointNumber"],

    components: {
        PointNumberLine,

  },
    data() {
        return {
            isEnglish: false,
            key: "",
            showMainPage: true,
            style: "",
            showSpecificInfo: false,
            infoToShow: "",
            imageToShow: "",
            periodToShow: "",
            placeToShow: "",
            nameToShow: "",
            materialToShow: "",
            showMoreInfoOfItem: false,
            keyToReRenderAudio: 0,
            showMoreInformation: false,
            index: 0,
            pointNumberBACK: "",
            specificItemDetails: "",
            titleList: localStorage.getItem("listTitle"),
            pointNumber: Number(localStorage.getItem("pointNumber")),
            pointNumberFromVitrineMain: Number(localStorage.getItem("pointNumberFromVitrineMain")),
            translation: {
                items: "מוצגים",
                back: "חזרה למסלול",
                  }
        };
    },
    mounted() {
        // I CHECK FIRST THE THE LIST OF THESE ITEMS HAS NOT BEEN DOWNLODED AND STORE IN VUEX YET. IF IT DOESN'T EXIST IN LOCALSTORAGE, IT MEANS THAT IT IT'S NOT IN VUEX
        if (!localStorage.getItem("vitrine" + this.pointNumberFromVitrineMain)) {
            this.$store.dispatch("fetchPointItems", {
                navigationName: "visitMuseumEinDor",
                pointNumber: Number(this.pointNumberFromVitrineMain),
            });
        } else {
            console.log("currentItems EXISTE DEJA DANS STORE.GETTERS");
        }
        if (this.$store.getters.lang == "en") {
            console.log("isEnglish")
            this.isEnglish = true
        }
    },
    computed: {
        lang() {
          return this.translate(this.$store.getters.lang);
        },
        loading() {
            return this.$store.getters.loading;
        },
        error() {
            return this.$store.getters.error;
        },
        currentItemsArray() {
            console.log("this.pointNumber", this.$store.getters.vitrine5);

            if (this.pointNumberFromVitrineMain == 1) return this.$store.getters.vitrine1
            if (this.pointNumberFromVitrineMain == 2) return this.$store.getters.vitrine2
            if (this.pointNumberFromVitrineMain == 3) return this.$store.getters.vitrine3
            if (this.pointNumberFromVitrineMain == 4) return this.$store.getters.vitrine4
            if (this.pointNumberFromVitrineMain == 5) return this.$store.getters.vitrine5
            if (this.pointNumberFromVitrineMain == 6) return this.$store.getters.vitrine6
            if (this.pointNumberFromVitrineMain == 7) return this.$store.getters.vitrine7
            if (this.pointNumberFromVitrineMain == 8) return this.$store.getters.vitrine8
            if (this.pointNumberFromVitrineMain == 9) return this.$store.getters.vitrine9
            if (this.pointNumberFromVitrineMain == 10) return this.$store.getters.vitrine10
            if (this.pointNumberFromVitrineMain == 11) return this.$store.getters.vitrine11
            if (this.pointNumberFromVitrineMain == 12) return this.$store.getters.vitrine12
            if (this.pointNumberFromVitrineMain == 13) return this.$store.getters.vitrine13
            if (this.pointNumberFromVitrineMain == 14) return this.$store.getters.vitrine14
            if (this.pointNumberFromVitrineMain == 15) return this.$store.getters.vitrine15
            if (this.pointNumberFromVitrineMain == 16) return this.$store.getters.vitrine16
            if (this.pointNumberFromVitrineMain == 17) return this.$store.getters.vitrine17
            if (this.pointNumberFromVitrineMain == 18) return this.$store.getters.vitrine18
            if (this.pointNumberFromVitrineMain == 19) return this.$store.getters.vitrine19
            if (this.pointNumberFromVitrineMain == 20) return this.$store.getters.vitrine20
            if (this.pointNumberFromVitrineMain == 21) return this.$store.getters.vitrine21
            if (this.pointNumberFromVitrineMain == 22) return this.$store.getters.vitrine22
            if (this.pointNumberFromVitrineMain == 23) return this.$store.getters.vitrine23
            if (this.pointNumberFromVitrineMain == 24) return this.$store.getters.vitrine24
            if (this.pointNumberFromVitrineMain == 25) return this.$store.getters.vitrine25
            if (this.pointNumberFromVitrineMain == 26) return this.$store.getters.vitrine26
            return this.$store.getters.currentItemsArray
        },
        points() {
            return this.$store.getters.points;
        },
        vitrinesMain() {
            return this.$store.getters.vitrinesMain;
        },
    },
    methods: {
        translate(lang) {
            switch (lang) {
                case 'he':
                this.translation = {
                    items: "מוצגים",
                back: "חזרה למסלול",
                                 }
                    break;
                case 'ar':
                this.translation = {
                    items: "العلامات التجارية",
                back: "خلف",
                    }
                    break;
                case 'en':
                this.translation = {
                    items: "Items",
                back: "Back",
                         }
                    break;
                default:

            }
        },
        closeSpeciticInfo() {
            if (this.pointNumber == 0) {
                setTimeout(() => {
                    this.showMoreInformation = false;
                    this.showSpecificInfo = false;
                }, 900);
                document.getElementById("specificInfoPage").className = "fadeOut over";
                console.log("index0");
            } else {
                setTimeout(() => {
                    this.showMoreInformation = true;
                    this.showSpecificInfo = false;
                }, 1000);
                document.getElementById("specificInfoPage").className = "fadeOut over";
                this.showMoreInformation = true;
            }
        },
        fadeOutMoreInfo() {
            this.pointNumberBACK = this.pointNumber - 1;
            setTimeout(() => {
                this.showMoreInformation = false;
            }, 1000);
            document.getElementById("moreInfo").className = "fadeOut over";
            setTimeout(() => {
                this.$router.push({ name: "visitMuseum" });
            }, 500);
            localStorage.removeItem("currentItems" + this.pointNumber);
        },
        startTour() {
            localStorage.setItem("pointNumber", 1);
            setTimeout(() => {
                this.showMoreInformation = false;
            }, 1000);
            document.getElementById("moreInfo").className = "fadeOut over";
            setTimeout(() => {
                this.$router.push({ name: "visitMuseum" });
            }, 500);
        },
        openImageInfo(name, imageUrl, material, period, place, info) {
            this.specificItemDetails = {
                infoToShow: info,
                imageToShow: imageUrl,
                periodToShow: period,
                placeToShow: place,
                materialToShow: material,
                nameToShow: name,
            };
            localStorage.setItem("specificItemDetails", JSON.stringify(this.specificItemDetails));
            this.$router.push({ name: "specificItemInfo" });
        },

        onDismissed() {
            this.$store.dispatch("clearError");
        },
    },
};
</script>

<style scoped>
.alignLeft {
    text-align: center !important;

}
.alignRight {
    text-align: right;
}
.ltr {
    direction: ltr;
    text-align: left !important;
}
.presented {
    color: white;
    font-size: 30px;
    font-weight: bold;
    position: relative;
    bottom: 11px;
    text-align: right;
}

.itemsRow {
    justify-content: center;
}

.itemInList:nth-child(even) {
    justify-content: start;
    padding-right: 5px;

}

.itemInList:nth-child(odd) {
    justify-content: end;
    padding-left: 5px;
}

/* a trailing item with no partner on its row should be centered in its own slot, not pushed to one edge */
.itemInList:last-child:nth-child(odd) {
    justify-content: center;
    padding-left: 0;
    padding-right: 0;
}

.justify-content-end {
    justify-content: end;
}

.justify-content-start {
    justify-content: start;
}

.itemSquare {
    height: 160px;
    width: 160px;
    border: solid 3px #63C4C3;
    background-color: white;
    border-radius: 20px;
}

.titleListName {
    position: absolute;
    top: -45px;
    width: 200px;
    background: white;
    height: 37px;
    z-index: 30;
    margin: 0 auto;
    width: 100%;
    text-align: center;
    padding-top: 5px;
    font-size: 20px;
}

.captionArrow {
    position: absolute;
    font-size: 12px;
    top: 23px;
    left: 30px;
}

.audioButton {
    width: 100%;
    border: 2px #79a541 solid;
    border-radius: 25px;
    height: 40px;
    margin-bottom: 16px;
    position: relative;
}

.titleSpan {
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 10px;
    color: #63C4C3;
    text-align: center;
    font-weight: bold;
}


.closingCross {
    position: relative;
    top: 0px;
    right: 24px;
    z-index: 20;
    color: black;
    font-size: 16px;
    z-index: 50;
}

.fadeIn {
    -webkit-animation: fadein 1s;
    /* Safari, Chrome and Opera > 12.1 */
    -moz-animation: fadein 1s;
    /* Firefox < 16 */
    -ms-animation: fadein 1s;
    /* Internet Explorer */
    -o-animation: fadein 1s;
    /* Opera < 12.1 */
    animation: fadein 1s;
}

.fadeOut {
    -webkit-animation: fadeOut 1s;
    /* Safari, Chrome and Opera > 12.1 */
    -moz-animation: fadeOut 1s;
    /* Firefox < 16 */
    -ms-animation: fadeOut 1s;
    /* Internet Explorer */
    -o-animation: fadeOut 1s;
    /* Opera < 12.1 */
    animation: fadeOut 1s;
}

@keyframes fadeOut {
    from {
        opacity: 1;
    }

    to {
        opacity: 0;
    }
}

/* Firefox < 16 */
@-moz-keyframes fadeOut {
    from {
        opacity: 1;
    }

    to {
        opacity: 0;
    }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadeOut {
    from {
        opacity: 1;
    }

    to {
        opacity: 0;
    }
}

/* Internet Explorer */
@-ms-keyframes fadeOut {
    from {
        opacity: 1;
    }

    to {
        opacity: 0;
    }
}

/* Opera < 12.1 */
@-o-keyframes fadeOut {
    from {
        opacity: 1;
    }

    to {
        opacity: 0;
    }
}

@keyframes fadein {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

/* Firefox < 16 */
@-moz-keyframes fadein {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadein {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

/* Internet Explorer */
@-ms-keyframes fadein {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

/* Opera < 12.1 */
@-o-keyframes fadein {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

.background {
    background-color: #63C4C3;
    background-size: cover;
    background-repeat: no-repeat;
    background-attachment: fixed;

}


.over {
    position: absolute;
    top: 50px;
    font-size: 18px;
    left: 0px;
    width: 100%;
    height: 100%;
    display: block;
    margin: 0px auto;
    background: white;
}

.center {
    display: block;
    margin: 0px auto;
}

.colorBtn {
    border-radius: 36px;
    min-height: 56px;
    color: white;
}


.container {
    margin-top: 16px;
    font-size: 20px;
    /* min-height: 100vh; */
}
</style>
